import { useState, useEffect } from 'react';
import axios from 'axios';

import { Branding } from '../dataProviders';


type Portal = {
  branding?: Branding
}

export const useLoadPortalConfig = (returnsCenterId: string | null) => {
  const [portal,setPortal] = useState<Portal>();

  useEffect( () => {
    if( !portal && returnsCenterId ) {
      axios.get(`/public/${returnsCenterId}`).then(
        response => setPortal(response.data),
        error => { throw new Error(error); }
      );
    }
  }, [portal, returnsCenterId] );

  if( !returnsCenterId ) {
    return {};
  }

  return portal || {};
}